import { render, staticRenderFns } from "./straddleHold.vue?vue&type=template&id=cbfc702a&scoped=true"
import script from "./straddleHold.vue?vue&type=script&lang=js"
export * from "./straddleHold.vue?vue&type=script&lang=js"
import style0 from "./straddleHold.vue?vue&type=style&index=0&id=cbfc702a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfc702a",
  null
  
)

export default component.exports